import { v4 as uuidv4 } from "uuid";
function chillHop() {
  return [
    {
      name: "On my Mind - Acoustic Version",
      artist: "Keenan Back",
      cover: "./assets/covers/Keenan-Back_On-My-Mind(Acoustic-Version).png",
      id: uuidv4(),
      audio: "./assets/songs/Keenan-Back_On-My-Mind(Acoustic-Version).wav",
      active: true,
      color: ["#fae001", "#292929"],
    },
    {
      name: "On my Mind - Studio Version",
      artist: "Keenan Back",
      cover: "./assets/covers/Keenan-Back_On-My-Mind.png",
      id: uuidv4(),
      audio: "./assets/songs/Keenan-Back_On-My-Mind.wav",
      active: false,
      color: ["#fae001", "#292929"],
    },
    {
      name: "Honest - Acoustic Version",
      artist: "Keenan Back",
      cover: "./assets/covers/Keenan-Back_Honest-Acoustic.png",
      id: uuidv4(),
      audio: "./assets/songs/Keenan-Back_Honest-Acoustic.wav",
      active: false,
      color: ["#fae001", "#292929"],
    },
    {
      name: "Blue Dancers",
      artist: "Keenan Back",
      cover: "./assets/covers/Keenan-Back_Blue-Dancers.jpg",
      id: uuidv4(),
      audio: "./assets/songs/Keenan-Back_Blue_Dancers.wav",
      active: false,
      color: ["#fae001", "#292929"],
    },
    {
      name: "What I Live For",
      artist: "Keenan Back",
      cover: "./assets/covers/Keenan-Back_What-I-Live-For.png",
      id: uuidv4(),
      audio: "./assets/songs/Keenan-Back_What-I-Live-For.wav",
      active: false,
      color: ["#fae001", "#292929"],
    },
    {
      name: "??????",
      artist: "Keenan Back",
      cover: "./assets/covers/Keenan-Back_Honest-Acoustic.png",
      id: uuidv4(),
      audio: "./assets/songs/Keenan-Back.mp3",
      active: false,
      color: ["#fae001", "#292929"],
    },
    {
      name: "Beacon",
      artist: "Keenan Back feat. Liam Back",
      cover: "./assets/covers/Keenan-Back-feat-Liam-Back_Beacon.png",
      id: uuidv4(),
      audio: "./assets/songs/Keenan-Back-feat-Liam-Back_Beacon.wav",
      active: false,
      color: ["#fae001", "#292929"],
    },
    {
      name: "Anymorning",
      artist: "Keenan Back",
      cover: "./assets/covers/Keenan-Back_Anymorning.jpg",
      id: uuidv4(),
      audio: "./assets/songs/Keenan-Back_Anymorning.mp3",
      active: false,
      color: ["#fae001", "#292929"],
    },
  ];
}

export default chillHop;
